import type { TRuleWithTheme } from '@/styles/theme';

export const passkeyOnlyRole: TRuleWithTheme<{ disabled: boolean }> = ({ theme, disabled }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(4),

    color: disabled ? theme.colors.foregroundsPlaceholder : theme.colors.foregroundsPrimary,

    cursor: disabled ? 'not-allowed' : 'pointer',
});

export const tooltipButton: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'help',
});
